import { Component, Input } from '@angular/core';

@Component({
  selector: '[app-menu]',
  templateUrl: './menu.component.html'
})

export class MenuComponent {

  @Input() items!: any[];
  @Input() idparent: string = 'MainMenu';

  constructor() {
  }
}


